import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrainingTableOption = _resolveComponent("TrainingTableOption")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TrainingTableOption, {
      icon: "edit-calendar-rounded",
      label: "Período de inscrição",
      response: 
      `${_ctx.formatDateOnly(_ctx.course.enrollmentStart)} até
       ${_ctx.formatDateOnly(_ctx.course.enrollmentEnd)}`
    
    }, null, 8, ["response"]),
    _createVNode(_component_TrainingTableOption, {
      icon: "calendar",
      label: "Data de realização",
      response: _ctx.formatMenusDates(_ctx.course.menus)
    }, null, 8, ["response"]),
    _createVNode(_component_TrainingTableOption, {
      icon: "time",
      label: "Horarios",
      response: _ctx.formatMenusSchedule(_ctx.course.menus)
    }, null, 8, ["response"]),
    _createVNode(_component_TrainingTableOption, {
      icon: "location",
      label: "Local",
      response: _ctx.getMenusLocation(_ctx.course.menus)
    }, null, 8, ["response"]),
    _createVNode(_component_TrainingTableOption, {
      icon: "people",
      label: "Inscritos",
      response: _ctx.formatEnrolledUsers(_ctx.course.maxCapacity, _ctx.numberOfEnrollUsers)
    }, null, 8, ["response"])
  ], 64))
}